import React, { useState, useEffect } from 'react'
import { Flex, Button, Alert, Input, Card, Typography, Result } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications';
import HeaderNoregister from '../../componentes/headerNoRegister';
import api from '../../service/axios'
import { responseMessage } from '../../service/util';
import dayjs from 'dayjs';


export const ValidaPJ = (props) => {

    const navigate = useNavigate()
    const { code } = useParams()
    const [codigo, setCodigo] = useState(code)
    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [data, setData] = useState(null)

    useEffect(() => {
        console.log(code)
        if (code) {
            consulta()
        }
    }, [])

    async function consulta() {
        try {
            if (!codigo) {
                addToast("Informe o Código de Autenticação para efetuar a consulta!", { appearance: 'error', autoDismiss: true });
                return
            }
            setLoading(true)
            const result = await api.get('api/v1.0/valida/certificado/pj', {
                params: { codigo: codigo }
            })
            setData(result.data)
            console.log(result.data)

        } catch (erro) {
            console.log('teste')
            setData(undefined)
            addToast(responseMessage(erro.message), { appearance: 'error', autoDismiss: true });

        }
        setLoading(false)
    }


    function renderConsulta() {
        return <Flex justify='center'>
            <Card style={{ marginTop: 50 }}>
                <Flex gap={5} vertical justify='center' align='center'>
                    <Typography.Title level={3}>Validar Certificado PJ</Typography.Title>
                    <br />
                    <Flex justify='center' style={{ textAlign: 'center' }}>
                        Informe o código de autenticação gerado na declaração emitida eletronicamente no campo abaixo.
                    </Flex>
                    <Input placeholder='Código de Autenticação' style={{ textAlign: 'center' }}
                        value={codigo}
                        onChange={event => {
                            setCodigo(event.target.value)
                        }} />


                    <Button type="primary" loading={loading} style={{ width: 150, marginTop: 15 }} onClick={() => consulta()}>
                        Validar
                    </Button>

                    {
                        data === undefined && <Alert style={{ marginTop: 15 }} message="Não foi localizado nenhum registro para os dados informados." type="error" />
                    }
                </Flex>
            </Card>
        </Flex>
    }


    function renderResultado() {
        return <Flex vertical justify='center' align='center' flex={1}>
            <Alert description={<Flex vertical align='center' justify='center'>

                

                <Flex><b>CÓDIGO DE AUTENTICAÇÃO</b> </Flex>
                <Flex>{codigo} </Flex>

                <Flex style={{ marginTop: 15 }}><b>EMPRESA</b></Flex>
                <Flex>{data?.cnpj} </Flex>
                <Flex>{data?.razao} </Flex>


                 <Flex style={{ marginTop: 15 }}><b>VALIDADE DO CERTIFICADO</b></Flex>
                <Flex>{dayjs(data?.validade).format('DD/MM/YYYY')} </Flex>
               

            </Flex>}
            />
        </Flex>
    }



    return <Flex vertical style={{ backgroundColor: 'whitesmoke', minHeight: '100vh' }} flex={1}>
        <HeaderNoregister />
        {data ? renderResultado() : renderConsulta()}
        <Flex justify='center' style={{ marginTop: 10 }}>
            <Button type='text' onClick={() => {
                navigate('/')
            }}>Voltar</Button>
        </Flex>
    </Flex>
}


export default ValidaPJ